import { useRef, useState, useEffect } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'
import womanImg from '../images/Parallax1_L.webp'
import { WomanContainer } from './styled'
const Woman = () => {
  const ref = useRef(null)
  const [isDesktop, setIsDesktop] = useState<boolean>(false)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['end end', 'start start'],
  })

  const move = useTransform(
    scrollYProgress,
    [0, 0.5, 1],
    ['0vw', '15vw', '30vw']
  )
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 1024)
    }

    handleResize() // set initial value
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  })

  return (
    <WomanContainer ref={ref}>
      <motion.div
        style={{
          width: 'fit-content',
          translateX: !isDesktop ? move : '0vw',
        }}
      >
        <img src={womanImg} alt="woman" />
      </motion.div>
    </WomanContainer>
  )
}
export default Woman
